import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'product' | 'article';
  noIndex?: boolean;
  /** Use title as-is without the brand suffix. */
  exactTitle?: boolean;
  jsonLd?: Record<string, unknown> | Array<Record<string, unknown>>;
}

const DEFAULT_TITLE = 'Grizzlee Gripz - Premium Pickleball OverGrip Solutions';
const DEFAULT_DESCRIPTION = 'Elevate your game with Grizzlee Gripz premium overgrips. Designed for tennis, pickleball, and paddle sports athletes who demand the best.';
const DEFAULT_IMAGE = 'https://www.grizzleegripz.com/lovable-uploads/5ef37510-2fdd-4779-962e-a1bea2b7b800.png';
const SITE_URL = 'https://www.grizzleegripz.com';
const TWITTER_HANDLE = '@GrizzleeGripz';

export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  noIndex = false,
  jsonLd,
  exactTitle = false,
}: SEOProps) => {
  const fullTitle = title ? (exactTitle ? title : `${title} | Grizzlee Gripz`) : DEFAULT_TITLE;
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Grizzlee Gripz" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
      <meta name="twitter:creator" content={TWITTER_HANDLE} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* No Index if specified */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Structured data */}
      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(schema)}
          </script>
        ))}
    </Helmet>
  );
};

export default SEO;
